<script setup lang="ts">
import { useMatchmakingDataStore } from '~/stores/matchmaking'
import RegionsStatisticsSection from '~/components/region-statistics/RegionsStatisticsSection.vue'

const props = defineProps<{ countyId?: string }>()
const matchmakingStore = useMatchmakingDataStore()
const matchmakingPosts = computed(() => {
  if (!props.countyId) return matchmakingStore.postsWithFilters
  return matchmakingStore.postsWithFilters.filter((post) => post.county === props.countyId)
})

const { keyTranslator: fuelTypeTranslator } = await useKeyTranslator('fuelType')

onMounted(async () => {
  await matchmakingStore.initData()
})
</script>

<template>
  <DataTable v-if="matchmakingPosts.length > 0" :value="matchmakingPosts">
    <Column field="operator_name" header="Behovsägare"></Column>
    <Column field="fuel_type" header="Drivmedel">
      <template #body="{ data }">
        <AppChips>
          <AppChipsItem
            v-for="fuelTypeId in data.fuel_type as number[]"
            :key="fuelTypeId"
            :item="fuelTypeTranslator(fuelTypeId as unknown as number)"
            type="outlined"
          />
        </AppChips>
      </template>
    </Column>
    <Column>
      <template #body="{ data }">
        <NuxtLink :to="`/samarbeta/${data.slug}`"><Button label="Gå till inlägg" link /></NuxtLink>
      </template>
    </Column>
  </DataTable>
  <div v-else>
    <p>Inga inlägg tillgängliga</p>
    <NuxtLink :to="`/samarbeta/skapa-inlagg`"><Button label="Skapa inlägg" /></NuxtLink>
  </div>
</template>
